import { cn } from '@/utils/cn';
import React from 'react';
import Icon from '../Icon';
import Text from '../Text';

function ProductFilterOption({ handleSelect, item }) {
  if (!item.name) {
    return null;
  }

  return (
    <div
      role="presentation"
      key={item.id}
      className="flex items-center justify-between px-4 py-8 cursor-pointer"
      onClick={() => handleSelect(item)}
    >
      <div className="flex items-center gap-[8px]">
        <Icon
          type={item.isChecked ? 'active-check-box' : 'check-box'}
          className={
            item.isChecked
              ? 'size-[19px] lg:size-[25px]'
              : 'size-[18px] lg:size-[24px]'
          }
        />
        <Text
          type="paragraph"
          className={cn(
            'text-14 lg:text-16 text-senate font-medium capitalize leading-20 tracking-[0.28px] lg:tracking-[0.32px]',
            {
              '!font-semibold !text-richcarmine': item.isChecked,
            },
          )}
        >
          {item.name?.en}
        </Text>
      </div>
      <Text
        type="paragraph"
        className={cn(
          'text-14 lg:text-16 text-senate font-medium capitalize leading-20 tracking-[0.28px] lg:tracking-[0.32px]',
          {
            '!font-semibold !text-richcarmine': item.isChecked,
          },
        )}
      >
        ({item.count})
      </Text>
    </div>
  );
}

export default ProductFilterOption;
